import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/loader/Loader";
import { getTransactionWithUsername } from "../../../services/Admin";
import formatDate from "../../../utils/formatDate";
import CustomTable from "../../components/custom-table/CustomTable";

const columns = [
  { Header: "S.No",            accessor: "sn" },
  { Header: "User Id",       accessor: "userId" },          // <-- New column
  { Header: "Full Name",       accessor: "fullname" },          // <-- New column
  { Header: "Amount (USDT)",   accessor: "amount" },
  { Header: "Date",            accessor: "date" },
  { Header: "Remark",          accessor: "transactionRemark" },
  { Header: "Status",          accessor: "status" },
  { Header: "To Address",      accessor: "toAddress" },
  { Header: "Txn Hash",        accessor: "txHash" },
];

function USDTWithdrawHistory() {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);

 useEffect(() => {
  async function fetchHistory() {
    setLoading(true);
    try {
      const txs = await getTransactionWithUsername("Withdraw", "debited");
      const formatted = txs.map((tx, i) => {
        let color = "#6b7280"; // gray
        if (tx.status === "Completed") color = "#10b981"; // green
        else if (tx.status === "Pending") color = "#f59e0b"; // orange

        return {
          sn: i + 1,
          fullname: tx.userName || "-",
          userId: tx.userId || "-",
          amount: tx.creditedAmount > 0
            ? `+${tx.creditedAmount}`
            : `${tx.debitedAmount}`,
          date: formatDate(tx.createdAt),
          transactionRemark: tx.transactionRemark || "-",
          status: (
            <span style={{ color, fontWeight: 500 }}>
              {tx.status}
            </span>
          ),
          toAddress: tx.toAddress,
          txHash:  (
            <a style={{ fontWeight: 500 }} href={`https://bscscan.com/tx/${tx.txHash || tx.txHash || tx.hash}`}>
              Hash
            </a>
          ),
        };
      });
      setHistory(formatted);
    } catch (err) {
      console.error("Error loading withdrawal history:", err);
      toast.error("Failed to load withdrawal history");
    } finally {
      setLoading(false);
    }
  }
  fetchHistory();
}, []);

  if (loading) return <Loader />;

  return (
    <div className="deposit">
      <h1 className="main-heading">USDT Withdrawal History</h1> 
      <br />
      <CustomTable
        columns={columns}
        data={history}
        heading="All USDT Transactions"
      />
    </div>
  );
}

export default USDTWithdrawHistory;
